import { Component, OnDestroy } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { WonderPush } from '@awesome-cordova-plugins/wonderpush/ngx';
import { Platform } from '@ionic/angular';
import { getAuth } from 'firebase/auth';
import mixpanel from 'mixpanel-browser';
import { Observable, Subject, Subscription, interval, map, filter } from 'rxjs';
import { Navigation, SwiperOptions } from 'swiper';
import { takeUntil } from 'rxjs/operators';
import { PaymentsStore } from '../payments/payments-store';
import { ActivatedRoute, Router, RoutesRecognized } from '@angular/router';
import { IToolbarData } from '../shared/models/components-data.models';
import { travelingQuotes } from '../shared/components/modals/traveling-modal/traveling-quotes';
import { environment } from '../../environments/environment';
import { UserService } from '../auth/user.service';
import { IUser } from '../auth/auth.models';
import { DateService } from '../services/date.service';
import { PushNotificationsService } from '../services/push-notifications.service';
import { AppService } from '../app.service';

const TOOLBAR_SWIPER: IToolbarData = {
  arrow: true,
  btnSlot: 'end',
  title: 'Notifications',
};
@Component({
  providers: [WonderPush],
  selector: 'app-home',
  templateUrl: 'main-menu.page.html',
  styleUrls: ['main-menu.page.scss'],
})
export class MainMenuPage implements OnDestroy {
  authUserId = '';
  config: SwiperOptions;
  balanceInfo;
  creator;
  disableTreasureButton;
  isSubscriptionModalOpen = false;
  isSubscriptionForPearlsModalOpen = false;
  isChatSubscription = false;
  isBuyPearlsModalOpen = false;
  hours = 0;
  minutes = 0;
  seconds = 0;
  isTimerActive = false;
  loading = true;
  modalLoader = false;
  routerTitle: string;
  notifications;
  TOOLBAR_SWIPER = TOOLBAR_SWIPER;
  isOpen = false;
  subscriptionPeriod;
  pearlsNumber;
  subscriptionByPearlsPrice;
  countdown: Observable<any>;
  intervalId;
  timerInfo;
  currentUser;
  properties;
  isUserPremium;
  showTravelingModal = false;
  travelingBg: string;
  random: number;
  routerLink: string[] | null;
  query = window.matchMedia('(max-width: 400px)');

  isMobile = this.platform.platforms().includes('capacitor');
  isIosApp = false;
  userSubscriptionInfo;
  userSubInfo;
  isAdmin = false;
  isPremium: boolean;
  inviters: IUser[];
  premiumNotifications: any[] = [];

  typesList = [
    'podJoinRequest',
    'newInvite',
    'subRenewal',
    'suspendedAppPremium',
    'suspendedPersonalPremium',
    'suspendedPaidPremium',
    'review',
    'chatSplash',
  ];
  private subscription: Subscription;
  private snapshot: Subscription;
  private balanceInfoSnapshot: Subscription;
  private timerInfoSnapshot: Subscription;
  private destroy$ = new Subject<void>();
  private timerSubscription$: Subscription;
  private activeSession = false;
  private inAppNotificationsMustBeHidden;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private fireStore: AngularFirestore,
    private paymentsStore: PaymentsStore,
    private platform: Platform,
    private userService: UserService,
    private dateService: DateService,
    private wonderPush: WonderPush,
    private notificationsService: PushNotificationsService,
    private appService: AppService
  ) {}

  async ionViewDidEnter() {
    mixpanel.init(environment.mixpanelToken, { debug: true });
    const { uid } = getAuth().currentUser;
    this.authUserId = uid;
    this.getUser();

    this.paymentsStore.getItemByByValue({ documentId: this.authUserId });
    const { pearls, subscription, number, period, type, price } =
      this.activatedRoute.snapshot.queryParams;
    if (pearls === 'success' || subscription === 'success') {
      if (pearls === 'success') {
        this.pearlsNumber = number;
        this.isBuyPearlsModalOpen = true;
      }
      if (subscription === 'success') {
        if (type === 'chat') {
          this.subscriptionPeriod = period;
          this.isSubscriptionModalOpen = true;
          this.isChatSubscription = true;
        } else {
          await this.userService.refreshPremiumSubscriptionForAuthUser(uid);
          this.subscriptionPeriod = period;
          this.isSubscriptionModalOpen = true;
          if (type === 'free') {
            this.subscriptionPeriod = period;
            this.subscriptionByPearlsPrice = price;
            this.isSubscriptionForPearlsModalOpen = true;
          }
        }
      }
    } else {
      this.getInfo();
    }
    this.paymentsStore.selectTreasureButtonStatus().subscribe(isOpen => {
      this.disableTreasureButton = isOpen;
    });

    this.trackEvent('Visit Screen', 'screen-name', 'Home');
  }

  ionViewDidLeave() {
    this.destroy$.next();
    this.destroy$.complete();
    if (this.timerSubscription$) {
      this.timerSubscription$.unsubscribe();
    }

    this.loading = false;
    this.authUserId = '';
    this.balanceInfo = null;
    this.paymentsStore.destroy$;
    this.paymentsStore.logOut();
    this.hours = 0;
    this.minutes = 0;
    this.seconds = 0;
    if (this.snapshot) {
      this.snapshot.unsubscribe();
    }
    if (this.balanceInfoSnapshot) {
      this.balanceInfoSnapshot.unsubscribe();
    }
    if (this.timerInfoSnapshot) {
      this.timerInfoSnapshot.unsubscribe();
    }
  }

  ionViewWillLeave() {
    this.loading = false;
    if (this.timerSubscription$) {
      this.timerSubscription$.unsubscribe();
    }

    this.destroy$.next();
    this.destroy$.complete();
    this.authUserId = '';
    this.balanceInfo = null;
    this.paymentsStore.destroy$;
    this.paymentsStore.logOut();
    this.hours = 0;
    this.minutes = 0;
    this.seconds = 0;
    if (this.snapshot) {
      this.snapshot.unsubscribe();
    }
    if (this.balanceInfoSnapshot) {
      this.balanceInfoSnapshot.unsubscribe();
    }
    if (this.timerInfoSnapshot) {
      this.timerInfoSnapshot.unsubscribe();
    }
  }

  ngOnDestroy(): void {
    if (this.timerSubscription$) {
      this.timerSubscription$.unsubscribe();
    }

    this.loading = false;
    this.destroy$.next();
    this.destroy$.complete();
    this.authUserId = '';
    this.balanceInfo = null;
    this.paymentsStore.destroy$;
    this.paymentsStore.logOut();
    this.hours = 0;
    this.minutes = 0;
    this.seconds = 0;
    if (this.snapshot) {
      this.snapshot.unsubscribe();
    }
    if (this.balanceInfoSnapshot) {
      this.balanceInfoSnapshot.unsubscribe();
    }
    if (this.timerInfoSnapshot) {
      this.timerInfoSnapshot.unsubscribe();
    }
  }

  trackEvent(event, parameter, parameterValue) {
    if (parameter === 'screen-name') {
      this.properties = {
        'screen-name': parameterValue,
      };
    }

    mixpanel.track(event, this.properties);
  }

  navigateToChat() {
    if (this.currentUser?.discordLink) {
      this.trackEvent('Visit Screen', 'screen-name', 'Discord');
      window.open(environment.discordServerLink, '_blank');
    } else {
      this.trackEvent('Visit Screen', 'screen-name', 'Discord');
      this.router.navigate(['/chat']);
    }
  }

  public startTimer(lastOpen): void {
    const endTime = new Date(lastOpen + 86400000);
    this.countdown = interval(1000).pipe(
      map(() => Math.floor(endTime.getTime() - new Date().getTime()))
    );
    this.timerSubscription$ = this.countdown.subscribe(secondsLeft => {
      if (secondsLeft <= 0) {
        this.isTimerActive = false;
        this.timerSubscription$.unsubscribe();
        this.paymentsStore.updateTreasureButtonStatus(false);
        this.loading = false;
      } else {
        this.isTimerActive = true;
        this.hours = Math.floor(secondsLeft / 3600000);
        this.minutes = Math.floor((secondsLeft - this.hours * 3600000) / 60000);
        this.seconds = Math.floor(
          (secondsLeft - (this.hours * 3600000 + this.minutes * 60000)) / 1000
        );
        this.paymentsStore.updateTreasureButtonStatus(true);
        this.loading = false;
      }
    });
  }

  getInfo() {
    this.listenBalanceInfoDetails();
    this.listenTimerInfoDetails();
    this.getNotification();
    this.router.events.subscribe(event => {
      if (event instanceof RoutesRecognized) {
        this.isOpen = false;
      }
    });
  }

  async getNotification() {
    this.snapshot = this.fireStore
      .collection('notifications')
      .doc(this.authUserId)
      .valueChanges()
      .subscribe(data => {
        if (!data) {
          return;
        }
        this.notifications = (data as any).notifications.reverse();
        if (!!this.notifications.length) {
          this.notifications = this.notifications
            .filter(item => item.type !== 'push')
            .filter(item => this.dateService.checkSuspendedNotification(item));
        }

        const invitations = (data as any).notifications.filter(
          not => not.type === 'newInvite'
        );

        if (invitations.length) {
          this.inviters = invitations[0].data?.reduce((accum, props) => {
            if (accum?.length) {
              if (accum?.find(item => item.userId === props.inviterId)) {
                return accum;
              } else {
                return [
                  ...accum,
                  {
                    userId: props.inviterId,
                    username: props.inviterUsername,
                    profilePicture: props.inviterPicture,
                  },
                ];
              }
            } else {
              return [
                {
                  userId: props.inviterId,
                  username: props.inviterUsername,
                  profilePicture: props.inviterPicture,
                },
              ];
            }
          }, []);
        } else {
          this.isOpen =
            this.notifications.length > 0 &&
            this.checkTypes(this.notifications, this.typesList);
        }

        this.isOpen =
          this.notifications.length > 0 &&
          this.checkTypes(this.notifications, this.typesList);
        if (this.isOpen) {
          this.config = {
            modules: [Navigation],
            allowTouchMove: false,
            slideNextClass: '.continue__button',
            navigation: {
              nextEl: '.continue__button',
            },
          };
        }
      });
  }

  checkTypes(array1: any[], array2: string[]): boolean {
    return array1.some(item1 => array2.includes(item1.type));
  }

  private listenBalanceInfoDetails() {
    this.balanceInfoSnapshot = this.fireStore
      .collection('info')
      .doc(this.authUserId)
      .valueChanges()
      .subscribe((data: any) => {
        this.balanceInfo = data as any;
        this.isAdmin = data?.role === 'admin';
      });
  }

  private listenTimerInfoDetails() {
    this.timerInfoSnapshot = this.fireStore
      .collection('info')
      .doc(this.authUserId)
      .get()
      .subscribe(data => {
        this.timerInfo = data.data() as any;
        if (!!this.timerInfo && this.timerInfo.lastTreasureOpening) {
          this.startTimer(this.timerInfo.lastTreasureOpening);
        } else {
          this.isTimerActive = false;
          this.paymentsStore.updateTreasureButtonStatus(false);
          this.loading = false;
        }
      });
  }

  private getUser() {
    this.loading = true;
    this.userService.currentUser$
      .pipe(
        takeUntil(this.destroy$),
        filter(user => !!user.uid)
      )
      .subscribe(user => {
        this.activeSession = this.currentUser?.uid === user?.uid;
        this.currentUser = user;
        this.isPremium = this.userService.isPremium;
        this.isAdmin = this.userService.isAdmin;
        mixpanel.identify(user.uid);
        this.authUserId = user.uid;
        this.listenBalanceInfoDetails();
        this.loading = false;
      });
  }

  travelTo(router, title, bg) {
    const isPremium = !!this.userService.isPremium;
    const isAdmin = !!this.userService.isAdmin;
    this.isPremium = isPremium;
    this.isAdmin = isAdmin;

    if (!environment.production) {
      console.info('[premium-gate]', {
        gate: 'main-menu-travel',
        uid: this.currentUser?.uid || this.authUserId,
        isPremium,
        isPaidPremium: !!this.userService.isPaidPremium,
        isAdmin,
        decision: !isPremium && !isAdmin ? 'show-travel-modal' : 'skip',
      });
    }

    if (!isPremium && !isAdmin) {
      const max = travelingQuotes.length;
      this.random = Math.round(0 - 0.5 + Math.random() * (max + 1));

      this.appService.travelingData.next({
        travelingRandom: this.random,
        travelingTitle: title,
        travelingLink: router,
        travelingBg: bg,
      });
      this.appService.showTravelingModal.next(true);
    }

    this.router.navigate(router);
    this.trackEvent('Visit Screen', 'screen-name', title);
  }

  closeTravelingModal(e) {
    this.showTravelingModal = !e;
  }
}

